import React, { ComponentType, FunctionComponent } from 'react';

import { AuthInterface } from '../auth';

const withLocalhostAuthenticator = <T extends object>(
  Component: ComponentType<T>,
  Auth: AuthInterface
) => {
  const AppWithAuthenticator: FunctionComponent<T> = props => {
    const user = Auth.currentAuthenticatedUser();

    if (user == null) {
      console.error(
        'User access and credentials must be set in .env for local development'
      );

      return null;
    }

    return <Component {...props} />;
  };

  return AppWithAuthenticator;
};

export default withLocalhostAuthenticator;
